// Constants
import { ORIENTATION_CHANGE_EVENT } from './constants/contract-viewer.handlers.constants';
// Enumerations
import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';
// Types
import {
  ContractViewerHandlersType,
  ContractViewerMethodsHandlersType,
} from './types/contract-viewer.handlers.type';
// Utilities
import { isMobileAndIsLandscape } from './utils/contract-viewer.handlers.utils';

const managePdfContractCompleteRenderEventHandler = (
  setLandscape: ContractViewerHandlersType['setLandscape']
): void => {
  setLandscape(false);
};

const managePdfContractErrorLoadEvenHandler = (
  setError: ContractViewerHandlersType['setError']
): void => {
  setError(AppErrorEnumeration.PDF_VIEWER_ERROR);
};

const watchMobileOrientationChangeEventHandler = ({
  setLandscape,
}: Pick<ContractViewerHandlersType, 'setLandscape'>): (() => void) => {
  const callback = () => {
    setLandscape(isMobileAndIsLandscape());
  };

  window.addEventListener(ORIENTATION_CHANGE_EVENT, callback);
  return () => {
    window.removeEventListener(ORIENTATION_CHANGE_EVENT, callback);
  };
};

const ContractViewerHandlers = ({
  setError,
  setLandscape,
}: ContractViewerHandlersType): ContractViewerMethodsHandlersType => ({
  handleManagePdfContractCompleteRenderEvent: () =>
    managePdfContractCompleteRenderEventHandler(setLandscape),
  handleManagePdfContractErrorLoadEvent: () => managePdfContractErrorLoadEvenHandler(setError),
  handleWatchMobileOrientationChangeEvent: () =>
    watchMobileOrientationChangeEventHandler({ setLandscape }),
});

export { ContractViewerHandlers };
